import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { AFormFields, Field, getFields } from '../../atoms/forms';

/**
 * The company's fields, fetched when a promotions page mounts. The app-wide
 * field list is loaded once per session, so a field created meanwhile (a
 * formula added in the settings) would stay missing from the promotion
 * columns until a reload; the cached list is shown until the fresh one comes.
 */
export function usePromotionFieldDefinitions(): Field[] {
	const cached = useRecoilValue(AFormFields);
	const [fresh, setFresh] = React.useState<Field[]>();
	React.useEffect(() => {
		let alive = true;
		getFields().then(fields => { if (alive) setFresh(fields); }).catch(() => undefined);
		return () => { alive = false; };
	}, []);
	return fresh ?? cached;
}
